import type { IconData } from '@stacksjs/iconify-core'

export const computersDevicesElectronicsMemory: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.135 12.19v6.1h3.05v12.19h1.53V1.52h-1.53v10.67Zm3.05 3.05h-1.52v-1.53h1.52ZM3.805 30.48h24.38V32H3.805Zm1.53-3.05h21.33v1.52H5.335Zm13.71-9.14h1.52v1.52h-1.52Zm-6.1 3.04h6.1v1.53h-6.1Zm-1.52-3.04h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M9.9 7.62H8.375v1.52h18.29V1.52h1.52V0H8.375v1.52H9.9Zm13.71-4.57h1.52v4.57h-1.52Zm-3.05 0h1.54v4.57h-1.53Zm-3.04 0h1.52v4.57h-1.52Zm-3.05 0H16v4.57h-1.52Zm-3.05 0h1.52v4.57h-1.52ZM6.855 1.52h1.52v1.53h-1.52Zm-1.52 1.53h1.52v1.52h-1.52Zm-1.53 1.52h1.53V6.1h-1.53Zm0 13.72h1.53v-6.1h-1.53V6.1h-1.52v24.38h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computersDevicesElectronicsMemory
